import { UsersService } from './../shared/services/users.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UntypedFormBuilder, Validators, UntypedFormGroup, ValidationErrors, UntypedFormControl, FormArray } from '@angular/forms';

import { UiService } from '@services/ui.service';
import { User } from '@classes/user/user';
import { RoleName } from '@enums/role-name.enum';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { TimeRecordsService } from '@services/timeRecords.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { Pagination } from '@classes/pagination/pagination';
import { TimeRecordType } from '@enums/type.enum';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-time-tracking',
  templateUrl: './time-tracking.component.html',
  styleUrls: ['./time-tracking.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class TimeTrackingComponent extends FormEditBaseComponent implements OnInit {

  drivers: User[];
  history: any[];

  displayedColumns = ['user', 'type', 'comment', 'createdOn', 'date'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  filterValue = null;
  sortValue: string;
  pagination: Pagination;

  filterForm = new UntypedFormGroup({
    user: new UntypedFormControl(),
    createdOn: new UntypedFormControl(),
    date: new UntypedFormControl(),
    type: new UntypedFormControl()
  })

  allTypes = [
    {
      value: 'all',
      name: "Tous"
    },
    {
      value: 1,
      name: 'Entrée'
    },
    {
      value: 2,
      name: 'Sortie'
    }
  ];

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private usersSrv: UsersService,
    private timeRecordsSrv: TimeRecordsService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSubscriptions();
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  // }

  isControlSet(control: string): boolean {
    return !!this.editForm.get(control);
  }

  onFinish(): void {
    this.editFinished.emit();
  }

  onSubmit(): void {
    this.isLoading = true;
    this.create();
  }

  private create(): void {
    const formValues = this.editForm.value;

    let userId = this.editForm.value.driver.id;
    let year = this.editForm.value.date.format('YYYY');
    let month = this.editForm.value.date.format('M');

    this.timeRecordsSrv.exportExcel(userId, year, month).subscribe(() => { });
  }

  private initSubscriptions(): void {
    this.isLoading = true;

    const newRequest = new PaginationRequest(
      this.filterValue,
      null,
      1
    );
    this.timeRecordsSrv.getHistory(newRequest);

    this.addSubscription(
      this.timeRecordsSrv.historyListChanged
        .subscribe(history => {
          this.history = history;
          this.initTable();
        })
    );

    const driversPromise = new Promise((resolve, reject) => {
      this.usersSrv.getList(null, true)
        .subscribe(driversFromSrv => {
          this.drivers = [...driversFromSrv].filter(oneDriver => oneDriver.role.name !== RoleName.admin_client && oneDriver.role.name !== RoleName.client);
          resolve(true);
        });
    });

    Promise.all([driversPromise])
      .then(() => {
        this.isLoading = false;
        this.initForm();
      });

    this.addSubscription(
      this.timeRecordsSrv.paginationSubject
        .subscribe(pagination => {
          this.pagination = pagination;
        })
    );
  }


  private initForm(): void {
    this.editForm = this.fb.group({
      driver: new UntypedFormControl(null, [Validators.required]),
      date: new UntypedFormControl(moment(new Date()), [Validators.required])
    });
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.editForm.value.date;
    ctrlValue.year(normalizedYear.year());
    // this.editForm.value.date.setValue.date(ctrlValue);
    this.editForm.get('date').setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.editForm.value.date;
    ctrlValue.month(normalizedMonth.month());
    // this.date.setValue(ctrlValue);
    this.editForm.get('date').setValue(ctrlValue);
    datepicker.close();
  }

  initTable() {
    this.dataSource = new MatTableDataSource(this.history);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'date': {
          return item.timeRecord.date
        }
        case 'user': {
          return item.timeRecord.user.username
        }
        default: return item[property];
      }
    };

    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  filterEnter(event: Event, column) {
    this.filterValue = this.filterForm.value;
    this.getList();
  }

  clearFilters(): void {
    this.filterForm.reset();
    this.filterValue = null;
    this.getList();
  }

  onFilter(): void {
    const formValue = this.filterForm.value;

    this.filterValue = formValue;
    this.getList();
  }

  onSortChanged(sortEvent: Sort): void {
    let direction = '';

    if (sortEvent.direction === 'asc') {
      direction = '';
    } else if (sortEvent.direction === 'desc') {
      direction = '-';
    }
    if (sortEvent.direction === '') {
      this.sortValue = null;
    } else {
      this.sortValue = ` ${direction}${sortEvent.active}`;
    }
    this.getList();
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.pagination.pageNumber = pageEvent.pageIndex + 1;
    this.getList();
  }

  getList(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      this.pagination.pageNumber,
    );

    this.timeRecordsSrv.getHistory(newRequest);
  }

  showTypeText(type: TimeRecordType): string {
    return 'timeTracking.type.' + TimeRecordType[type];
  }

}
